import type { Module } from 'vuex';
import { GlobalPair } from '@/types/GlobalPair';
import {RootState} from "@/store";

export interface GlobalPairState {
  globalPair: GlobalPair | null;
  deleted: boolean;
}

const globalPairModule: Module<GlobalPairState, RootState> = {
  namespaced: true,

  state: (): GlobalPairState => ({
    globalPair: null,
    deleted: false,
  }),

  mutations: {
    setGlobalPair(state, payload: any) {
      state.globalPair = GlobalPair.fromRaw(payload);
      state.deleted = false;
    },

    setGlobalPairUpdate(state, payload: { 
      idGlobalPair: number; 
      showOnMainPage?: boolean; 
      useInQuantfury?: boolean; 
      locked?: boolean; 
    }) {
      if (!state.globalPair || state.globalPair.idGlobalPair !== payload.idGlobalPair) return;
      if (payload.showOnMainPage !== undefined) state.globalPair.showOnMainPage = payload.showOnMainPage;
      if (payload.useInQuantfury !== undefined) state.globalPair.useInQuantfury = payload.useInQuantfury;
      if (payload.locked !== undefined) state.globalPair.locked = payload.locked;
    },

    setGlobalPairDelete(state, payload: { idGlobalPair: number }) {
      if (state.globalPair?.idGlobalPair === payload.idGlobalPair) {
        state.deleted = true;
      }
    },

    setGlobalPairLock(state, payload: { idGlobalPair: number }) {
      if (state.globalPair?.idGlobalPair === payload.idGlobalPair) {
        state.globalPair.locked = true;
      }
    },

    setGlobalPairUnlock(state, payload: { idGlobalPair: number }) {
      if (state.globalPair?.idGlobalPair === payload.idGlobalPair) {
        state.globalPair.locked = false;
      }
    },

    clearGlobalPair(state) {
      state.globalPair = null;
      state.deleted = false;
    },

    updateGlobalPairData(state, payload: any) {
      if (!state.globalPair || state.globalPair.idGlobalPair !== payload.idGlobalPair) return;
    },
  },

  actions: {
    wsSetGlobalPair({ commit }, payload) {
      commit('setGlobalPair', payload);
    },
    wsSetEmptyGlobalPair({ commit }) {
      commit('clearGlobalPair');
    },
    wsGlobalPairUpdate({ commit }, payload) {
      commit('setGlobalPairUpdate', payload);
    },
    wsGlobalPairDelete({ commit }, payload) {
      commit('setGlobalPairDelete', payload);
    },
    wsGlobalPairLock({ commit }, payload) {
      commit('setGlobalPairLock', payload);
    },
    wsGlobalPairUnlock({ commit }, payload) {
      commit('setGlobalPairUnlock', payload);
    },
    clearGlobalPair({ commit }) {
      commit('clearGlobalPair');
    },
  },
};

export default globalPairModule; 